(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canfish-feature-grid-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-feature-grid-v2')) {
    customElements.define('cf-feature-grid-v2', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.mobile = matchMedia('(max-width:767px)');
        this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target;
          video.dataset.visible = entry.isIntersecting ? 'true' : 'false';
          if (entry.isIntersecting && !document.hidden && !this.reduce.matches) video.play().catch(() => {});
          else video.pause();
        }), {threshold: 0.05});
        this.mount = () => {
          for (const media of this.querySelectorAll('.cf-media')) {
            const template = (this.mobile.matches && media.querySelector('[data-mobile-video]')) || media.querySelector('[data-desktop-video]');
            if (!template || media.selectedTemplate === template) continue;
            const previous = media.querySelector('video');
            if (previous) { this.observer.unobserve(previous); previous.pause(); previous.remove(); }
            media.selectedTemplate = template;
            const video = template.content.firstElementChild.cloneNode(true);
            media.append(video);
            this.observer.observe(video);
          }
        };
        this.sync = () => this.querySelectorAll('video').forEach(video => {
          if (!document.hidden && !this.reduce.matches && video.dataset.visible === 'true') video.play().catch(() => {});
          else video.pause();
        });
        this.mount();
        this.mobile.addEventListener('change', this.mount, {signal: this.abort.signal});
        this.reduce.addEventListener('change', this.sync, {signal: this.abort.signal});
        document.addEventListener('visibilitychange', this.sync, {signal: this.abort.signal});
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('.cf-media').forEach(media => { media.selectedTemplate = null; const video = media.querySelector('video'); if (video) { video.pause(); video.remove(); } });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canfish-feature-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cf-feature-grid')) {
    customElements.define('cf-feature-grid', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        this.mobile = matchMedia('(max-width:767px)');
        this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target;
          video.dataset.visible = entry.isIntersecting ? 'true' : 'false';
          if (entry.isIntersecting && !document.hidden && !this.reduce.matches) video.play().catch(() => {});
          else video.pause();
        }), {threshold: 0.05});
        this.mount = () => {
          for (const media of this.querySelectorAll('.cf-media')) {
            const template = (this.mobile.matches && media.querySelector('[data-mobile-video]')) || media.querySelector('[data-desktop-video]');
            if (!template || media.selectedTemplate === template) continue;
            const previous = media.querySelector('video');
            if (previous) { this.observer.unobserve(previous); previous.pause(); previous.remove(); }
            media.selectedTemplate = template;
            const video = template.content.firstElementChild.cloneNode(true);
            media.append(video);
            this.observer.observe(video);
          }
        };
        this.sync = () => this.querySelectorAll('video').forEach(video => {
          if (!document.hidden && !this.reduce.matches && video.dataset.visible === 'true') video.play().catch(() => {});
          else video.pause();
        });
        this.mount();
        this.mobile.addEventListener('change', this.mount, {signal: this.abort.signal});
        this.reduce.addEventListener('change', this.sync, {signal: this.abort.signal});
        document.addEventListener('visibilitychange', this.sync, {signal: this.abort.signal});
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.querySelectorAll('.cf-media').forEach(media => { media.selectedTemplate = null; const video = media.querySelector('video'); if (video) { video.pause(); video.remove(); } });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canfish-price-compare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cf-price-slider')) {
 customElements.define('cf-price-slider', class extends HTMLElement {
  connectedCallback() {
   this.frame = requestAnimationFrame(() => this.setup());
  }
  setup() {
   this.grid = this.querySelector('.pc-grid');
   const nav = this.querySelector('.pc-dots');
   if (!this.grid || !nav) return;
   this.cards = Array.from(this.grid.querySelectorAll(':scope > .pc-card'));
   nav.replaceChildren();
   nav.hidden = this.cards.length < 2;
   this.controller = new AbortController();
   const options = { signal:this.controller.signal };
   this.dots = this.cards.map((card, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'pc-dot';
    dot.setAttribute('aria-label', (card.querySelector('.pc-title')?.textContent.trim() || String(index + 1)));
    dot.addEventListener('click', () => this.go(index), options);
    nav.append(dot);
    return dot;
   });
   this.grid.addEventListener('scroll', () => {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.update());
   }, { ...options, passive:true });
   this.addEventListener('shopify:block:select', event => {
    const index = this.cards.findIndex(card => card.contains(event.target));
    if (index >= 0 && matchMedia('(max-width:767px)').matches) this.go(index);
   }, options);
   this.observer = new ResizeObserver(() => this.update());
   this.observer.observe(this.grid);
   this.update();
  }
  target(card) {
   const position = card.getBoundingClientRect().left - this.grid.getBoundingClientRect().left + this.grid.scrollLeft;
   return Math.max(0, Math.min(position, this.grid.scrollWidth - this.grid.clientWidth));
  }
  go(index) {
   this.grid.scrollTo({ left:this.target(this.cards[index]), behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth' });
  }
  update() {
   let active = 0;
   let distance = Infinity;
   this.cards.forEach((card, index) => {
    const next = Math.abs(this.target(card) - this.grid.scrollLeft);
    if (next < distance) { distance = next; active = index; }
   });
   this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
  }
  disconnectedCallback() {
   cancelAnimationFrame(this.frame);
   this.controller?.abort();
   this.observer?.disconnect();
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["canfish-video-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('canfish-video-tabs')) {
    customElements.define('canfish-video-tabs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.tabs = [...this.querySelectorAll('[role=tab]')];
        this.cards = [...this.querySelectorAll('.cfv__card')];
        this.track = this.querySelector('.cfv__track');
        this.dialog = this.querySelector('dialog');
        this.mount = this.querySelector('.cfv__mount');
        this.dockButton = this.querySelector('.cfv__dock');
        this.expandButton = this.querySelector('.cfv__expand');
        this.dockButton.hidden = this.dataset.mini !== 'true';
        this.tabs.forEach(tab => {
          tab.addEventListener('click', () => this.select(tab), options);
          tab.addEventListener('keydown', event => {
            const index = this.tabs.indexOf(tab);
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault(); this.select(this.tabs[next]); this.tabs[next].focus();
          }, options);
        });
        this.cards.forEach(card => card.querySelector('.cfv__play').addEventListener('click', () => this.open(card), options));
        this.querySelector('.cfv__prev').addEventListener('click', () => this.scroll(-1), options);
        this.querySelector('.cfv__next').addEventListener('click', () => this.scroll(1), options);
        this.track.addEventListener('scroll', () => this.arrows(), options);
        this.querySelector('.cfv__close').addEventListener('click', () => this.stop(), options);
        this.dockButton.addEventListener('click', () => this.mode(true), options);
        this.expandButton.addEventListener('click', () => this.mode(false), options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.stop(); }, options);
        this.dialog.addEventListener('click', event => { if(event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom) this.stop(); } }, options);
        document.addEventListener('cfv:play', event => { if(event.detail !== this) this.stop(false); }, options);
        document.addEventListener('shopify:block:select', event => { const card=this.cards.find(item=>item.dataset.blockId===event.detail.blockId); if(!card)return; const tab=this.tabs.find(item=>item.dataset.category===card.dataset.category); if(tab)this.select(tab); card.scrollIntoView({block:'nearest',inline:'center'}); }, options);
        this.resize = new ResizeObserver(() => this.arrows()); this.resize.observe(this.track);
        this.observer = new IntersectionObserver(entries => { if(!entries[0].isIntersecting && this.dialog.open && !this.dialog.classList.contains('is-mini') && this.dataset.autoDock==='true' && this.dataset.mini==='true') this.mode(true); });
        this.observer.observe(this.querySelector('.cfv__carousel'));
        if(this.tabs.length) this.select(this.tabs[0]); else this.arrows();
      }
      select(tab) {
        this.tabs.forEach(item => { const active=item===tab; item.setAttribute('aria-selected',String(active)); item.tabIndex=active?0:-1; });
        this.cards.forEach(card => { card.hidden=card.dataset.category!==tab.dataset.category; });
        this.querySelector('[role=tabpanel]').setAttribute('aria-labelledby',tab.id);
        this.querySelector('.cfv__empty').hidden=this.cards.some(card=>!card.hidden);
        this.track.scrollLeft=0; this.arrows();
      }
      arrows() { const end=this.track.scrollWidth-this.track.clientWidth; this.querySelector('.cfv__prev').disabled=this.track.scrollLeft<2; this.querySelector('.cfv__next').disabled=this.track.scrollLeft>=end-2; }
      scroll(direction) { this.track.scrollBy({left:direction*this.track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'}); }
      open(card) {
        document.dispatchEvent(new CustomEvent('cfv:play',{detail:this}));
        this.stop(false);
        this.opener=card.querySelector('.cfv__play');
        this.mount.replaceChildren(card.querySelector('template').content.cloneNode(true));
        const video=this.mount.querySelector('video');
        if(!video)return;
        this.querySelector('.cfv__error').hidden=true;
        video.addEventListener('error',()=>{ this.querySelector('.cfv__error').hidden=false; },{signal:this.controller.signal});
        this.dialog.classList.remove('is-mini');
        this.dockButton.hidden=this.dataset.mini!=='true'; this.expandButton.hidden=true;
        this.dialog.showModal();
        video.play().catch(()=>{});
      }
      mode(mini) {
        if(!this.dialog.open)return;
        const video=this.mount.querySelector('video'); const playing=video && !video.paused;
        this.dialog.close(); this.dialog.classList.toggle('is-mini',mini);
        this.dockButton.hidden=mini || this.dataset.mini!=='true'; this.expandButton.hidden=!mini;
        if(mini)this.dialog.show(); else this.dialog.showModal();
        if(playing)video.play().catch(()=>{});
        if(mini && this.opener)this.opener.focus({preventScroll:true});
      }
      stop(focus=true) { const video=this.mount.querySelector('video'); if(video)video.pause(); if(this.dialog.open)this.dialog.close(); this.mount.replaceChildren(); if(focus && this.opener && this.opener.isConnected)this.opener.focus({preventScroll:true}); }
      disconnectedCallback() { this.stop(false); this.controller.abort(); this.resize.disconnect(); this.observer.disconnect(); this.initialized=false; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
